import { CommonModule } from '@angular/common'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from '@angular/core'
import { createCustomElement } from '@angular/elements'
import { BrowserModule } from '@angular/platform-browser'
import { authInterceptor } from '../../shared/interceptors/auth/auth.interceptor'
import { ScheduleRecurrencePageComponent } from './schedule-recurrence-page/schedule-recurrence-page.component'
import { ScheduleRuleComponent } from './widgets/schedule-rule/schedule-rule.component'
import { ScheduleRulesListComponent } from './widgets/schedule-rules-list/schedule-rules-list.component'

@NgModule({
  declarations: [ScheduleRecurrencePageComponent],
  imports: [CommonModule, BrowserModule, ScheduleRulesListComponent, ScheduleRuleComponent],
  providers: [provideHttpClient(withInterceptors([authInterceptor])), BrowserModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ScheduleRecurrenceModule {
  constructor(private injector: Injector) {}

  ngDoBootstrap() {
    const rulesListWc = createCustomElement(ScheduleRulesListComponent, {
      injector: this.injector
    })
    customElements.define('visio-schedule-recurrence-wc', rulesListWc)

    const ruleWc = createCustomElement(ScheduleRuleComponent, {
      injector: this.injector
    })
    customElements.define('visio-schedule-rule-wc', ruleWc)
  }
}
